/**
 * 通知ドロワーの行と新着ポップアップの文言 — 英語。
 * 形は `notificationsJa` と同じでなければならない (TranslationOf がキーの欠落・余分をエラーにする)。
 * 集約した文は 2 件以上のときだけ出る (1 件は BE の title をそのまま出す) ので、複数形で書いてよい。
 */
import type { TranslationOf } from '../../types';
import type { notificationsJa } from '../ja/notifications';

export const notificationsEn: TranslationOf<typeof notificationsJa> = {
  group: {
    itemUploadedNamed: '{client} uploaded {count} files for {resource}',
    itemUploadedGeneric: '{client} uploaded {count} documents',
    itemAddedNamed: '{client} added {count} documents: "{resource}"',
    itemAddedGeneric: '{client} added {count} documents',
    itemDeferredNamed: '{client} will submit "{resource}" later',
    itemDeferredGeneric: '{client} will submit a document later',
    extensionRequestedNamed: '{client} is asking for a deadline extension for "{resource}"',
    extensionRequestedGeneric: '{client} is asking for a deadline extension for a document',
    messagesReceived: 'Received {count} messages from {client}',
  },
  drawer: {
    documentsCount: 'Documents: {count}',
    namedCount: '{name}: {count}',
    unknownDate: 'Unknown date',
  },
  categories: {
    document: 'Document submissions',
    review: 'Document review',
    message: 'Messages',
    guide: 'Notices and reminders',
    email: 'Email delivery',
    case: 'Cases',
    task: 'Tasks',
    other: 'Other',
  },
  surfaces: {
    collection: 'Document collection',
    message: 'Messages',
    email: 'Email',
    case: 'Case',
    task: 'Tasks',
  },
  popup: {
    fallbackTitle: 'New notification',
    messageAction: 'View message',
    messageTitle: 'New message from {client}',
    aggregated: 'New notifications: {count}',
  },
};
